//src/pages/CoursesCatalog

import React, { useEffect, useState } from "react";
import api from "../api/api";
import CourseCard from "../components/common/CourseCard";
import Spinner from "../components/common/Spinner";

export default function CoursesCatalog() {
  const [courses, setCourses] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    async function loadCourses() {
      try {
        const res = await api.get("/courses/public");
        setCourses(res.data.courses || []);
      } catch (err) {
        console.error("Erro ao carregar catálogo", err);
      } finally {
        setLoading(false);
      }
    }

    loadCourses();
  }, []);

  if (loading) {
    return (
      <div className="py-20 flex justify-center">
        <Spinner />
      </div>
    );
  }

  return (
    <div className="container mx-auto px-6 py-16">
      <h1 className="text-3xl font-bold mb-12 neon-text text-center">
        Catálogo de Cursos
      </h1>

      {courses.length === 0 ? (
        <p className="text-center opacity-70">
          Nenhum curso disponível no momento.
        </p>
      ) : (
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-8">
          {courses.map(course => (
            <CourseCard key={course.id} course={course} />
          ))}
        </div>
      )}
    </div>
  );
}
